module.exports = __webpack_public_path__ + "static/media/in_yan.7937ca56.webp";